import React from 'react'
import dropIconWhite from '@assets/CustomIcons/moving-white.svg'
import dropIcon from '@assets/CustomIcons/moving.svg'

export function OrderDragOverlay({ isOver, canDrop }: { isOver?: boolean; canDrop?: boolean }) {
  return (
    <div
      className={`remove-order-overlay  ${isOver ? 'active' : ''}`}
      style={{
        zIndex: 3,
        visibility: canDrop ? 'visible' : 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className='remove-message'>
        <div>
          <img className='drop-icon' src={isOver ? dropIconWhite : dropIcon} alt='Drop Icon' />
        </div>
        Remove Order From Schedule
      </div>
    </div>
  )
}
